<template>
  <div id="data-view">
    <dv-full-screen-container :style="viewStyle">
      <mx-page type="Home" :config="config" :name="config.Title + '顶部'" theme="Panel" style="width: 100%" @event="onClick"></mx-page>
      <mx-page type="Home" :config="config" :name="config.Title + '第一排'" theme="Panel" style="width: 100%"></mx-page>
      <div class="flex-row start middle m20">
        <div style="flex: 1">
          <mx-page type="Home" :config="config" :name="config.Title + '第二排左侧'" theme="Panel" class="m1"></mx-page>
        </div>
        <div class="flex-row start top" style="flex: 2">
          <mx-page type="Home" :config="config" :name="config.Title + '第二排中间'" theme="Panel" style="width: 50%" class="m1"></mx-page>
          <mx-page type="Home" :config="config" :name="config.Title + '第二排中间1'" theme="Panel" style="width: 50%" class="m1"></mx-page>
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
export default {
  name: 'DataView',
  props: {
    value: Object,
    config: Object
  },
  data() {
    return { height: 60, switch: false, viewStyle: 'left:0' }
  },
  computed: {
    Now() {
      return this.$matrix.formatDateTime(new Date()).replaceAll('/', '-')
    },

    Theme() {
      if (this.config && this.config.Theme) return this.config.Theme
      return 'top'
    }
  },
  mounted() {
    if (this.$refs.nav) {
      this.height = this.$refs.nav.$el.clientHeight + 10
    } else {
      this.height = 0
    }
  },
  methods: {
    onClick(e) {
      if (e) {
        this.viewStyle = 'left:0'
      } else {
        this.$matrix.Goto(`/company?t=${new Date().getTime()}`)
      }
    }
  },
  created() {
    let user = this.$matrix.GetUser()
    if (!user) this.$matrix.GotoLogin()
  }
}
</script>

<style scoped>
.root {
  display: block;

  overflow-x: hidden;
  position: relative;
  background-color: #f7f7f7;
  /* border-top-left-radius: 20px;
  padding: 20px; */
}

.data-panel {
  margin: 20px 0;
}

.box-con {
  margin: 40px 0;
}

.box {
  padding: 20px;
  margin: 10px;
  border-radius: 10px;
}
</style>
